// extracted by mini-css-extract-plugin
module.exports = {"pricingInfoContainer":"planInfo_pricingInfoContainer__UAl6V","priceDecimal":"planInfo_priceDecimal__10WHW","fadein":"planInfo_fadein__aLuQ9","loading":"planInfo_loading__GvgH7"};